export enum MetricsPaths {
    WebinarReports = "/users/webinar-reports",
    Universal = "/users/universal",
    OrderReports = "/users/order-reports",
    PaymentReports = "/users/payment-reports",
    AdReports = "/users/ad-reports"
}
